import { Block } from "modules/Block";

import factsMetricsTemplate from "./FactsBlock.hbs";

import "./facts-block.scss";

export class FactsBlock extends Block<typeof FactsBlock> {
    static readonly className = "js-facts-block";

    private selectLabel: HTMLElement | null = null;
    private selectToggle: HTMLInputElement | null = null;
    private selectOptions: HTMLLIElement[] = [];
    private metricsWrapper: HTMLElement | null = null;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.metricsWrapper = rootElement.querySelector<HTMLElement>(".metric-wrapper");        
        this.initSelect();
        this.setBackgroundImage();
    }

    setBackgroundImage() {
        const backgroundImageUrl = this.rootElement.querySelector("img")?.getAttribute("src");
        if (backgroundImageUrl) {
            this.rootElement.style.backgroundImage = `url(${backgroundImageUrl})`;
        }
    }

    // TODO: This should be a reusable select component
    initSelect() {
        this.selectLabel = this.rootElement.querySelector<HTMLLIElement>('.dropdown__filter-selected');
        this.selectToggle = this.rootElement.querySelector<HTMLInputElement>('.dropdown__switch');
        this.selectOptions = Array.from(this.rootElement.querySelectorAll<HTMLLIElement>('.dropdown__select-option'));

        this.selectToggle?.addEventListener("change", this.handleToggleChange);

        this.selectOptions.forEach((option) => {
            option.addEventListener('click', this.handleOptionClick);
        });
    }

    handleToggleChange = () => {
        if (this.selectToggle?.checked) {
            document.addEventListener('click', this.handleClickOutsideDropdown);
        } else {
            document.removeEventListener('click', this.handleClickOutsideDropdown);
        }
    }

    handleClickOutsideDropdown = (e: MouseEvent) => {
        e.stopPropagation();

        const toggle = this.rootElement.querySelector<HTMLInputElement>('.dropdown__switch');
        const targetElement = e.target as Element;

        if (!toggle || targetElement === toggle) return;

        const isDropdownChild = targetElement.closest('.dropdown');

        if (!isDropdownChild) {
            toggle.checked = false;
        }
    }

    handleOptionClick = (e: Event) => {
        e.stopPropagation();
        const option = e.currentTarget;

        if (!this.selectLabel || !(option instanceof HTMLElement)) return;

        this.selectLabel.textContent = option.textContent;

        const dataset = option.dataset;

        if (dataset) {
            this.renderData(dataset);
        }
    }

    renderData(dataset: DOMStringMap) {
        const parseData = (data: string | undefined) => {
            const [label = "", metric = ""] = data?.split(",") || [];
            return { label, metric };
        };

        const set1 = parseData(dataset.set1);
        const set2 = parseData(dataset.set2);
        const set3 = parseData(dataset.set3);

        const templateData = {
            Label1: set1.label,
            Metric1: set1.metric,
            Label2: set2.label,
            Metric2: set2.metric,
            Label3: set3.label,
            Metric3: set3.metric,
        };

        if (!this.metricsWrapper) return;

        this.metricsWrapper.innerHTML = factsMetricsTemplate(templateData);
    }
}